import { render, staticRenderFns } from "./dSocialLangsBar.vue?vue&type=template&id=1c0db08a&"
import script from "./dSocialLangsBar.vue?vue&type=script&lang=js&"
export * from "./dSocialLangsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports